import { CSSObject } from '@chakra-ui/react';

export const Indicator = (): CSSObject => ({
  display: 'none',
});
